import React, { Suspense, useEffect } from 'react';
import { prop } from 'ramda';

import { ManagedPopup } from '@core/js/components/common/Popup';
import { useCombinedOnClose } from '@core/js/components/common/PopupManager';
import { Login } from '@core/js/components/main/Login';
import { WebContentInner } from '@core/js/components/system/WebContent';

import { BACKBONE_APP_ROOT } from '@core/js/backbone/constants';
import { useTranslations } from '@core/js/hooks/i18n';
import { scrollService } from '@core/js/services/scroll.service';
import { useAppSelector, useAuthSelector, useUserSelector } from '@core/js/store/hooks';

import style from './LoginPopup.scss';

const layerClassNames = {
    layout: style.layout,
    header: style.header
};

export const LoginPopup = ({ id, title, onClose, onLogin, controls }) => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const loginWebContent = useAppSelector(prop('loginWebContent'));
    const closePopup = useCombinedOnClose(onClose, id);
    const isLoginInProcess = useAuthSelector(prop('isLoginInProcess'));
    const t = useTranslations();

    useEffect(() => {
        if (!isLoggedIn || isLoginInProcess) {
            return;
        }

        if (onLogin) {
            onLogin();
        }

        closePopup();
        scrollService.scrollTo(0);
    }, [closePopup, isLoggedIn, onLogin, isLoginInProcess]);

    return (
        <ManagedPopup
            id={id}
            title={title || t('playtech.mobile.system.login.popup-title')}
            controls={controls}
            onClose={closePopup}
            className={`${style.container} ${title ? '' : style.container__gap}`}
            classNames={style}
            layerClassNames={layerClassNames}
        >
            <Suspense fallback="">
                <Login
                    className={`${style.loginPopupContainer} ${BACKBONE_APP_ROOT}`}
                />
            </Suspense>
            {loginWebContent &&
                <WebContentInner
                    popupId={id}
                    content={loginWebContent}
                    className={`${style.loginWc} ${BACKBONE_APP_ROOT}`}
                />
            }
        </ManagedPopup>
    );
};
